import React, { useEffect, useState } from "react";
import JsBarcode from "jsbarcode";

interface BarcodeCellProps {
    productId: string;
}

const generateBarcodeDataUrl = (productId: string): string => {
    const canvas = document.createElement("canvas");
    JsBarcode(canvas, String(productId), {
        format: "CODE128",
        width: 2,
        height: 60,
        displayValue: false,
    });
    return canvas.toDataURL("image/png");
};

const printBarcode = (dataUrl: string, productId: string) => {
    // Remove any leftover print iframe from a previous call
    const existing = document.getElementById("barcode-print-frame");
    if (existing) existing.remove();

    const iframe = document.createElement("iframe");
    iframe.id = "barcode-print-frame";
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow?.document;
    if (!doc) return;

    doc.open();
    doc.write(`
        <html>
            <head>
                <title>Barcode - ${productId}</title>
                <style>
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }
                    body {
                        padding: 4px;
                        text-align: center;
                    }
                    img {
                        display: inline-block;
                        width: 200px;
                        height: 60px;
                    }
                    @page {
                        margin: 0;
                    }
                </style>
            </head>
            <body>
                <img src="${dataUrl}" alt="barcode" />
                <p>${productId}</p>
            </body>
        </html>
    `);
    doc.close();

    const img = doc.querySelector("img");
    const triggerPrint = () => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
    };

    if (img && !img.complete) {
        img.onload = triggerPrint;
    } else {
        triggerPrint();
    }

    iframe.contentWindow?.addEventListener("afterprint", () => {
        iframe.remove();
    });
};

export const BarcodeCell: React.FC<BarcodeCellProps> = ({ productId }) => {
    const [dataUrl, setDataUrl] = useState<string>("");

    useEffect(() => {
        if (!productId) return;
        setDataUrl(generateBarcodeDataUrl(productId));
    }, [productId]);

    if (!productId || !dataUrl) return null;

    return (
        <div className="flex flex-col items-center gap-1">
            <img src={dataUrl} alt="barcode" style={{ width: "100px", height: "30px" }} />
            <p className="text-xs text-gray-600">{productId}</p>
            <button
                type="button"
                onClick={() => printBarcode(dataUrl, productId)}
                className="text-xs text-blue-600 underline hover:text-blue-800"
            >
                Print
            </button>
        </div>
    );
};